import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ReportFileExports from 'components/Reports/FileExports';
import ApiHelper from 'utils/apiHelper';
import ReportVisualization from 'components/Reports/ReportVisualization';

const ReportsPolicySummary = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [policySummaryData, setPolicySummaryData] = useState([]);
    const [filters, setFilters] = useState({});
    const [exportLoading, setExportLoading] = useState(false);

    useEffect(() => {
        getPolicySummaryData();
    }, []);

    const getPolicySummaryData = () => {
        setLoading(true);
        ApiHelper.get('/api/reports/policy_summary/')
            .then((res) => {
                setPolicySummaryData(res.data);
                setLoading(false);
                setFilters({
                    report: 'Policy Summary',
                    filterData: []
                });
            })
            .catch((err) => {
                if (err.response.status !== 401) {
                    setLoading(false);
                    toast.warning('There is no policy summary data');
                }
            });
    };

    return (
        <MainCard title="Operational Reports Management" cardHeaderTitle="Policy Summary" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>
                        Lists the policies in use and the number of devices using those policies
                    </Typography>
                </Grid>
                {policySummaryData.length > 0 && (
                    <Grid item xs={2}>
                        <ReportFileExports
                            downloadFileName="policy_summary"
                            downloadFileOption="all"
                            data={policySummaryData}
                            headers={[
                                { label: 'Policy Name', key: 'policy_name' },
                                { label: 'Locked', key: 'locked' },
                                { label: 'Type', key: 'type' },
                                { label: 'Description', key: 'description' },
                                { label: 'Start Time', key: 'start_time' },
                                { label: 'End Time', key: 'end_time' },
                                { label: 'Days', key: 'days' },
                                { label: 'Name', key: 'name' },
                                { label: 'CPU AC', key: 'cpu_ac' },
                                { label: 'MON AC', key: 'mon_ac' },
                                { label: 'CPU DC', key: 'cpu_dc' },
                                { label: 'MON DC', key: 'mon_dc' },
                                { label: 'Device Count', key: 'device_count' }
                            ]}
                            filters={filters}
                            setExportLoading={setExportLoading}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <ReportVisualization
                        loading={loading}
                        data={policySummaryData}
                        type="table"
                        tableHeaders={[
                            'Policy Name',
                            'Locked',
                            'Type',
                            'Description',
                            'Start Time',
                            'End Time',
                            'Days',
                            'Name',
                            'CPU AC',
                            'MON AC',
                            'CPU DC',
                            'MON DC',
                            'Device Count'
                        ]}
                        tableData={policySummaryData.map((data) => [
                            data.policy_name,
                            data.locked === '0' ? 'False' : 'True',
                            data.type,
                            data.description,
                            data.start_time,
                            data.type === 'Scheme' ? data.end_time : '',
                            data.days,
                            data.name,
                            data.cpu_ac,
                            data.mon_ac,
                            data.cpu_dc,
                            data.mon_dc,
                            data.device_count
                        ])}
                    />
                </Grid>
            </Grid>
            {exportLoading === true ? (
                <div className="overlayStyle">
                    <div className="spinner spinnerStyle"></div>
                </div>
            ) : null}
        </MainCard>
    );
};

export default ReportsPolicySummary;
